import client from './client'
import { ApplicationShareInfo, GenerateShareCodeInfo } from '@/types'

export const getNewShareInfoList = () => {
  return client<{ detail: ApplicationShareInfo[] }>({
    method: 'GET',
    url: 'shares',
  })
}

export const generateShareCode = (data: GenerateShareCodeInfo) => {
  return client<unknown>({
    method: 'POST',
    url: 'share',
    data,
  })
}

export const validateNewShareCode = (promotion: string) => {
  return client<{ isvalid: boolean }>({
    method: 'GET',
    url: 'share/check',
    params: { share: promotion },
  })
}

export const subscribeShareAutomation = (params: {
  share: string;
  org_id: number;
}) => {
  return client<{ url: string }>({
    method: 'POST',
    url: 'share/auto-open',
    data: params,
  })
}

export const addNewShareLinkClickCount = (promotion: string) => {
  return client<unknown>({
    method: 'POST',
    url: 'share/add-hit',
    data: { share: promotion },
  })
}
